module.exports = __webpack_public_path__ + "img/Vector.cc587098.png";